import React, { useMemo, useState } from 'react';
import { Collapse, Dropdown, ListGroup } from 'react-bootstrap';
import { ChevronDown, ChevronUp, Pin } from 'react-bootstrap-icons';
import { FormControl } from 'react-bootstrap';
import { contactSearchPaths, inventoryPaths } from '../../helpers/constants';
import { search } from '../../helpers/search';

const searchPaths = [...contactSearchPaths, ...inventoryPaths.map(p => `inventoryUnit[]/${p}`)];
const allSalesLocationObject = { _id: 'all', location: 'All' };

const ContactList = ({ contacts = [], importedContacts = [], activeId = '', onSelect, appChoices, externalSearchQuery = null, onQuickSearch, showSearch = true}) => {
  const [query, setQuery] = useState('');
  const [selectedSaleLocation, setSelectedSaleLocation] = useState(allSalesLocationObject);
  const [importedContactsExpanded, setImportedContactsExpanded] = useState(false);
  const searchQuery = onQuickSearch ? '' : ((externalSearchQuery !== null && externalSearchQuery !== '') ? externalSearchQuery : query);

  const filteredContacts = useMemo(() => {
    const contactsByLocation = contacts.filter(
      c =>
        selectedSaleLocation._id === 'all' ||
        (c['salesLocation']?._id || c['salesLocation']) === selectedSaleLocation._id
    );

    return search(contactsByLocation, searchPaths, searchQuery, '_id');
  }, [searchQuery, selectedSaleLocation, contacts]);

  const filteredImportedContacts = useMemo(() => {
    const importedContactsByLocation = importedContacts.filter(
      c =>
        selectedSaleLocation._id === 'all' ||
        (c['salesLocation']?._id || c['salesLocation']) === selectedSaleLocation._id
    );

    return search(importedContactsByLocation, searchPaths, searchQuery, '_id');
  }, [searchQuery, selectedSaleLocation, importedContacts]);

  const salesLocations = useMemo(
    () => [allSalesLocationObject, ...appChoices.find(a => a.key === 'salesLocation').values],
    [appChoices]
  );

  const renderContactItem = (c, isImported) => (
    <ListGroup.Item
      style={{
        fontSize: 14,
        backgroundColor: c['_id'] === activeId ? '' : isImported ? '#f0f0f0' : 'transparent'
      }}
      className={`py-1 text-${c['_id'] === activeId ? 'white' : 'dark'}`}
      key={c['_id']}
      action
      active={c['_id'] === activeId}
      onClick={() => onSelect && onSelect(c)}
    >
      {c['buyer']}
    </ListGroup.Item>
  );

  return (
    <div className="px-2">
      {showSearch && <div className="d-flex mb-2">
        <div className="flex-grow-1 mr-1">
          <FormControl size="sm" placeholder="Name, phone or email…" value={onQuickSearch ? externalSearchQuery : query} onChange={e => onQuickSearch ? onQuickSearch(e.target.value) : setQuery(e.target.value)} />
        </div>
        {!onQuickSearch && <Dropdown drop="down">
          <Dropdown.Toggle size="sm" block variant="outline-primary" id="dropdown-basic">
            <Pin className="mr-3 align-text-bottom" />
          </Dropdown.Toggle>

          <Dropdown.Menu
            align="start"
            popperConfig={{
              strategy: 'fixed',
              modifiers: [
                { name: 'preventOverflow', options: { boundary: 'window' } },
                { name: 'offset', options: { offset: [-210, 4] } }
              ]
            }}
          >
            {salesLocations.map(s => (
              <Dropdown.Item
                className={`${s._id === selectedSaleLocation._id ? 'bg-primary text-white' : ''}`}
                onClick={() => setSelectedSaleLocation(s)}
                key={s._id}
              >
                {s.location}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>}
      </div>}
      {filteredImportedContacts.length > 0 && (
        <div className={`${importedContactsExpanded ? 'mb-3' : ''}`}>
          <h6
            className="px-2 smallFont text-primary d-flex align-items-center pointer"
            onClick={() => setImportedContactsExpanded(!importedContactsExpanded)}
            style={{ cursor: 'pointer' }}
          >
            {importedContactsExpanded ? (
              <ChevronUp size={13} className="ml-1" />
            ) : (
              <ChevronDown size={13} className="ml-1" />
            )}
            <span className="flex-grow-1 ml-1">
              {importedContactsExpanded ? 'Hide' : 'Show'} Imported Contacts
              <b> ({filteredImportedContacts.length})</b>
            </span>
          </h6>
          <Collapse in={importedContactsExpanded}>
            <div>
              <ListGroup>
                {filteredImportedContacts.map(c => renderContactItem(c, true))}
              </ListGroup>
            </div>
          </Collapse>
        </div>
      )}
      {filteredContacts.length > 0 ? (
        <ListGroup>
          {filteredContacts.map(c => renderContactItem(c, false))}
        </ListGroup>
      ) : (
        filteredImportedContacts.length === 0 && (
          <h6 className="py-5 text-center border rounded smallFont">No contacts to show</h6>
        )
      )}
    </div>
  );
};

export default ContactList;
